import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

import { SubmitButton } from 'components';
import { Button } from 'components/chroma';

import {
  FunnelType,
  PaymentMethod,
  SingleFieldStepProps,
} from 'scenes/common/types';
import { SegmentedControlQuestion } from 'scenes/common/components/Questions';
import BpayDisclaimer from './BpayDisclaimer/BpayDisclaimer';

const PAYMENT_METHOD = 'paymentMethod';

const toDisplayOptions = (options: PaymentMethod[]) =>
  options.map((option) => ({ label: option, value: option }));

const BuyOnlineButtonWrapper = styled.div`
  text-align: center;
`;

const PaymentMethodStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'onNext' | 'defaultStateValue'> & {
    paymentMethodOptions: PaymentMethod[];
    onBpayPayment: () => void;
    emailAddress: string;
    policyStartDate: string;
    productType: FunnelType;
  }
> = ({
  defaultStateValue,
  paymentMethodOptions,
  onBpayPayment,
  onNext,
  emailAddress,
  policyStartDate,
  productType,
}) => {
  const {
    formState: hooksForm,
    handleSubmit,
    control,
    watch,
    errors,
  } = useForm({
    mode: 'onChange',
  });

  const displayOptions = toDisplayOptions(paymentMethodOptions);

  const watchedPaymentMethod = watch(PAYMENT_METHOD, defaultStateValue);

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SegmentedControlQuestion
        errors={errors}
        control={control}
        stateKey={PAYMENT_METHOD}
        options={displayOptions}
        defaultValue={defaultStateValue}
        question="Payment method"
        validationRules={{
          validate: {
            oneOf: (value) =>
              displayOptions.some((option) => option.value === value),
          },
        }}
      />
      {watchedPaymentMethod === PaymentMethod.BPAY ? (
        <>
          <BpayDisclaimer
            emailAddress={emailAddress}
            policyStartDate={policyStartDate}
            productType={productType}
          />
          <BuyOnlineButtonWrapper>
            <Button primary maxWidth onClick={onBpayPayment}>
              Buy online today
            </Button>
          </BuyOnlineButtonWrapper>
        </>
      ) : (
        <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
      )}
    </form>
  );
};

export default PaymentMethodStep;
